export const pageTransition = {
    in: {
        opacity: 1
    },
    out: {
        opacity: 0
    }
}